
import { computed, defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router/index'
import SearchCourse from './search.vue'
import { useStore } from 'vuex'
export default defineComponent({
  components: { SearchCourse },
  setup() {
    type pageDataType = {
      menulist: any
      selectedKeys?: Array<string>
      theme?: string | undefined
    }
    const route = useRoute()
    const store = useStore()
    const pageData: pageDataType = reactive({
      menulist: [],
      selectedKeys: [],
      theme: (route.query.theme as string) || 'light'
    })
    watch(
      () => route.query.theme,
      () => {
        const theme = route.query.theme as string
        pageData.theme = theme || 'light'
      }
    )
    const jfschoolroutes = router.options.routes.filter((item: any) => item.name === 'jfschool')
    pageData.menulist = jfschoolroutes[0].children?.filter((item: any) => !item.meta?.hide)
    function navclick(item: any) {
      const query = JSON.parse(JSON.stringify(route.query))
      delete query.groupCode
      delete query.courseNo
      delete query.groupName
      delete query.lessonNo

      const dom: any = document.querySelector('.jfschool > main')
      dom.scrollTop = 0
      router.push({
        name: item.name,
        query: query
      })
    }
    pageData.selectedKeys = [(route.meta.pname || route.name) as string]
    watch(
      () => route.name,
      () => {
        pageData.selectedKeys = [(route.meta.pname || route.name) as string]
      }
    )
    router.beforeEach((to, from, next) => {
      if (from.name === 'allcourse' || from.name === 'coursedetail') {
        store.commit('setBreadcrumbList', [
          {
            title: '全部课程',
            routename: ''
          },
          {
            title: '课程详情',
            routename: ''
          }
        ])
      } else if (from.name === 'excellentcourse') {
        if (to.params.groupName) {
          store.commit('setBreadcrumbList', [
            {
              title: '精选课程',
              routename: ''
            },
            {
              title: to.params.groupName as string,
              routename: ''
            },
            {
              title: '课程详情',
              routename: ''
            }
          ])
        } else {
          store.commit('setBreadcrumbList', [
            {
              title: '精品课程',
              routename: ''
            },
            {
              title: '课程详情',
              routename: ''
            }
          ])
        }
      } else if (from.name === 'specialcourse' || from.name === 'selectedtopics') {
        if (to.params.nogroupName === 'true' || !to.params.groupName) {
          store.commit('setBreadcrumbList', [
            {
              title: '全部课程',
              routename: ''
            },
            {
              title: '课程详情',
              routename: ''
            }
          ])
        } else {
          store.commit('setBreadcrumbList', [
            {
              title: '精选专题',
              routename: ''
            },
            {
              title: to.params.groupName as string,
              routename: ''
            },
            {
              title: '课程详情',
              routename: ''
            }
          ])
        }
      }
      next()
    })
    return {
      ...toRefs(pageData),
      navclick
    }
  }
})
